(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["responsive-video-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var wrappers = document.querySelectorAll('[data-video-wrapper]');
  wrappers.forEach(function(wrap){
    var video = wrap.querySelector('video');
    if (!video) return;

    var onReady = function(){
      wrap.classList.remove('video-is-loading');
      wrap.classList.add('video-is-ready');
    };

    if (video.readyState >= 1) onReady();
    video.addEventListener('loadedmetadata', onReady, { once: true });

    // Ensure autoplay works if enabled; fall back to showing controls
    if (video.hasAttribute('autoplay')) {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function(){
          video.removeAttribute('autoplay');
          video.setAttribute('controls', 'controls');
        });
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
